module.exports = __webpack_public_path__ + "static/media/M74ws.93744871.pdf";